// This file is auto-generated by scripts/generate-models.ts
// Do not edit manually - run 'npm run generate-models' to update

import type { Model } from "../types.ts";

export const NVIDIA_MODELS = {
	"meta/llama-3.1-70b-instruct": {
		id: "meta/llama-3.1-70b-instruct",
		name: "Llama 3.1 70b Instruct",
		api: "openai-completions",
		provider: "nvidia",
		baseUrl: "https://integrate.api.nvidia.com/v1",
		headers: {"NVCF-POLL-SECONDS":"3600"},
		compat: {"supportsStore":false,"supportsDeveloperRole":false,"supportsReasoningEffort":false,"maxTokensField":"max_tokens","supportsStrictMode":false,"supportsLongCacheRetention":false},
		reasoning: false,
		input: ["text"],
		cost: {
			input: 0,
			output: 0,
			cacheRead: 0,
			cacheWrite: 0,
		},
		contextWindow: 128000,
		maxTokens: 4096,
	} satisfies Model<"openai-completions">,
	"meta/llama-3.1-8b-instruct": {
		id: "meta/llama-3.1-8b-instruct",
		name: "Llama 3.1 8B Instruct",
		api: "openai-completions",
		provider: "nvidia",
		baseUrl: "https://integrate.api.nvidia.com/v1",
		headers: {"NVCF-POLL-SECONDS":"3600"},
		compat: {"supportsStore":false,"supportsDeveloperRole":false,"supportsReasoningEffort":false,"maxTokensField":"max_tokens","supportsStrictMode":false,"supportsLongCacheRetention":false},
		reasoning: false,
		input: ["text"],
		cost: {
			input: 0,
			output: 0,
			cacheRead: 0,
			cacheWrite: 0,
		},
		contextWindow: 16000,
		maxTokens: 4096,
	} satisfies Model<"openai-completions">,
	"meta/llama-3.2-11b-vision-instruct": {
		id: "meta/llama-3.2-11b-vision-instruct",
		name: "Llama 3.2 11b Vision Instruct",
		api: "openai-completions",
		provider: "nvidia",
		baseUrl: "https://integrate.api.nvidia.com/v1",
		headers: {"NVCF-POLL-SECONDS":"3600"},
		compat: {"supportsStore":false,"supportsDeveloperRole":false,"supportsReasoningEffort":false,"maxTokensField":"max_tokens","supportsStrictMode":false,"supportsLongCacheRetention":false},
		reasoning: false,
		input: ["text", "image"],
		cost: {
			input: 0,
			output: 0,
			cacheRead: 0,
			cacheWrite: 0,
		},
		contextWindow: 128000,
		maxTokens: 4096,
	} satisfies Model<"openai-completions">,
	"meta/llama-3.2-90b-vision-instruct": {
		id: "meta/llama-3.2-90b-vision-instruct",
		name: "Llama-3.2-90B-Vision-Instruct",
		api: "openai-completions",
		provider: "nvidia",
		baseUrl: "https://integrate.api.nvidia.com/v1",
		headers: {"NVCF-POLL-SECONDS":"3600"},
		compat: {"supportsStore":false,"supportsDeveloperRole":false,"supportsReasoningEffort":false,"maxTokensField":"max_tokens","supportsStrictMode":false,"supportsLongCacheRetention":false},
		reasoning: false,
		input: ["text", "image"],
		cost: {
			input: 0,
			output: 0,
			cacheRead: 0,
			cacheWrite: 0,
		},
		contextWindow: 128000,
		maxTokens: 8192,
	} satisfies Model<"openai-completions">,
	"meta/llama-3.3-70b-instruct": {
		id: "meta/llama-3.3-70b-instruct",
		name: "Llama 3.3 70b Instruct",
		api: "openai-completions",
		provider: "nvidia",
		baseUrl: "https://integrate.api.nvidia.com/v1",
		headers: {"NVCF-POLL-SECONDS":"3600"},
		compat: {"supportsStore":false,"supportsDeveloperRole":false,"supportsReasoningEffort":false,"maxTokensField":"max_tokens","supportsStrictMode":false,"supportsLongCacheRetention":false},
		reasoning: false,
		input: ["text"],
		cost: {
			input: 0,
			output: 0,
			cacheRead: 0,
			cacheWrite: 0,
		},
		contextWindow: 128000,
		maxTokens: 4096,
	} satisfies Model<"openai-completions">,
	"minimaxai/minimax-m3": {
		id: "minimaxai/minimax-m3",
		name: "MiniMax-M3",
		api: "openai-completions",
		provider: "nvidia",
		baseUrl: "https://integrate.api.nvidia.com/v1",
		headers: {"NVCF-POLL-SECONDS":"3600"},
		compat: {"supportsStore":false,"supportsDeveloperRole":false,"supportsReasoningEffort":false,"maxTokensField":"max_tokens","supportsStrictMode":false,"supportsLongCacheRetention":false},
		reasoning: true,
		input: ["text", "image"],
		cost: {
			input: 0,
			output: 0,
			cacheRead: 0,
			cacheWrite: 0,
		},
		contextWindow: 1000000,
		maxTokens: 16384,
	} satisfies Model<"openai-completions">,
	"mistralai/mistral-large-3-675b-instruct-2512": {
		id: "mistralai/mistral-large-3-675b-instruct-2512",
		name: "Mistral Large 3 675B Instruct 2512",
		api: "openai-completions",
		provider: "nvidia",
		baseUrl: "https://integrate.api.nvidia.com/v1",
		headers: {"NVCF-POLL-SECONDS":"3600"},
		compat: {"supportsStore":false,"supportsDeveloperRole":false,"supportsReasoningEffort":false,"maxTokensField":"max_tokens","supportsStrictMode":false,"supportsLongCacheRetention":false},
		reasoning: false,
		input: ["text", "image"],
		cost: {
			input: 0,
			output: 0,
			cacheRead: 0,
			cacheWrite: 0,
		},
		contextWindow: 262144,
		maxTokens: 262144,
	} satisfies Model<"openai-completions">,
	"mistralai/mistral-small-4-119b-2603": {
		id: "mistralai/mistral-small-4-119b-2603",
		name: "mistral-small-4-119b-2603",
		api: "openai-completions",
		provider: "nvidia",
		baseUrl: "https://integrate.api.nvidia.com/v1",
		headers: {"NVCF-POLL-SECONDS":"3600"},
		compat: {"supportsStore":false,"supportsDeveloperRole":false,"supportsReasoningEffort":false,"maxTokensField":"max_tokens","supportsStrictMode":false,"supportsLongCacheRetention":false},
		reasoning: true,
		input: ["text", "image"],
		cost: {
			input: 0,
			output: 0,
			cacheRead: 0,
			cacheWrite: 0,
		},
		contextWindow: 128000,
		maxTokens: 8192,
	} satisfies Model<"openai-completions">,
	"moonshotai/kimi-k2.6": {
		id: "moonshotai/kimi-k2.6",
		name: "Kimi K2.6",
		api: "openai-completions",
		provider: "nvidia",
		baseUrl: "https://integrate.api.nvidia.com/v1",
		headers: {"NVCF-POLL-SECONDS":"3600"},
		compat: {"supportsStore":false,"supportsDeveloperRole":false,"supportsReasoningEffort":false,"maxTokensField":"max_tokens","supportsStrictMode":false,"supportsLongCacheRetention":false},
		reasoning: true,
		input: ["text", "image"],
		cost: {
			input: 0,
			output: 0,
			cacheRead: 0,
			cacheWrite: 0,
		},
		contextWindow: 262144,
		maxTokens: 262144,
	} satisfies Model<"openai-completions">,
	"nvidia/nemotron-3-nano-30b-a3b": {
		id: "nvidia/nemotron-3-nano-30b-a3b",
		name: "nemotron-3-nano-30b-a3b",
		api: "openai-completions",
		provider: "nvidia",
		baseUrl: "https://integrate.api.nvidia.com/v1",
		headers: {"NVCF-POLL-SECONDS":"3600"},
		compat: {"supportsStore":false,"supportsDeveloperRole":false,"supportsReasoningEffort":false,"maxTokensField":"max_tokens","supportsStrictMode":false,"supportsLongCacheRetention":false},
		reasoning: true,
		input: ["text"],
		cost: {
			input: 0,
			output: 0,
			cacheRead: 0,
			cacheWrite: 0,
		},
		contextWindow: 131072,
		maxTokens: 131072,
	} satisfies Model<"openai-completions">,
	"nvidia/nemotron-3-nano-omni-30b-a3b-reasoning": {
		id: "nvidia/nemotron-3-nano-omni-30b-a3b-reasoning",
		name: "Nemotron 3 Nano Omni",
		api: "openai-completions",
		provider: "nvidia",
		baseUrl: "https://integrate.api.nvidia.com/v1",
		headers: {"NVCF-POLL-SECONDS":"3600"},
		compat: {"supportsStore":false,"supportsDeveloperRole":false,"supportsReasoningEffort":false,"maxTokensField":"max_tokens","supportsStrictMode":false,"supportsLongCacheRetention":false},
		reasoning: true,
		input: ["text", "image"],
		cost: {
			input: 0,
			output: 0,
			cacheRead: 0,
			cacheWrite: 0,
		},
		contextWindow: 256000,
		maxTokens: 65536,
	} satisfies Model<"openai-completions">,
	"nvidia/nemotron-3-super-120b-a12b": {
		id: "nvidia/nemotron-3-super-120b-a12b",
		name: "Nemotron 3 Super",
		api: "openai-completions",
		provider: "nvidia",
		baseUrl: "https://integrate.api.nvidia.com/v1",
		headers: {"NVCF-POLL-SECONDS":"3600"},
		compat: {"supportsStore":false,"supportsDeveloperRole":false,"supportsReasoningEffort":false,"maxTokensField":"max_tokens","supportsStrictMode":false,"supportsLongCacheRetention":false},
		reasoning: true,
		input: ["text"],
		cost: {
			input: 0.2,
			output: 0.8,
			cacheRead: 0,
			cacheWrite: 0,
		},
		contextWindow: 262144,
		maxTokens: 262144,
	} satisfies Model<"openai-completions">,
	"nvidia/nemotron-3-ultra-550b-a55b": {
		id: "nvidia/nemotron-3-ultra-550b-a55b",
		name: "Nemotron 3 Ultra 550B A55B",
		api: "openai-completions",
		provider: "nvidia",
		baseUrl: "https://integrate.api.nvidia.com/v1",
		headers: {"NVCF-POLL-SECONDS":"3600"},
		compat: {"supportsStore":false,"supportsDeveloperRole":false,"supportsReasoningEffort":false,"maxTokensField":"max_tokens","supportsStrictMode":false,"supportsLongCacheRetention":false},
		reasoning: true,
		input: ["text"],
		cost: {
			input: 0.5,
			output: 2.5,
			cacheRead: 0.15,
			cacheWrite: 0,
		},
		contextWindow: 1000000,
		maxTokens: 65536,
	} satisfies Model<"openai-completions">,
	"nvidia/nvidia-nemotron-nano-9b-v2": {
		id: "nvidia/nvidia-nemotron-nano-9b-v2",
		name: "nvidia-nemotron-nano-9b-v2",
		api: "openai-completions",
		provider: "nvidia",
		baseUrl: "https://integrate.api.nvidia.com/v1",
		headers: {"NVCF-POLL-SECONDS":"3600"},
		compat: {"supportsStore":false,"supportsDeveloperRole":false,"supportsReasoningEffort":false,"maxTokensField":"max_tokens","supportsStrictMode":false,"supportsLongCacheRetention":false},
		reasoning: true,
		input: ["text"],
		cost: {
			input: 0,
			output: 0,
			cacheRead: 0,
			cacheWrite: 0,
		},
		contextWindow: 131072,
		maxTokens: 131072,
	} satisfies Model<"openai-completions">,
	"openai/gpt-oss-120b": {
		id: "openai/gpt-oss-120b",
		name: "GPT-OSS-120B",
		api: "openai-completions",
		provider: "nvidia",
		baseUrl: "https://integrate.api.nvidia.com/v1",
		headers: {"NVCF-POLL-SECONDS":"3600"},
		compat: {"supportsStore":false,"supportsDeveloperRole":false,"supportsReasoningEffort":false,"maxTokensField":"max_tokens","supportsStrictMode":false,"supportsLongCacheRetention":false},
		reasoning: true,
		input: ["text"],
		cost: {
			input: 0,
			output: 0,
			cacheRead: 0,
			cacheWrite: 0,
		},
		contextWindow: 128000,
		maxTokens: 8192,
	} satisfies Model<"openai-completions">,
	"openai/gpt-oss-20b": {
		id: "openai/gpt-oss-20b",
		name: "GPT OSS 20B",
		api: "openai-completions",
		provider: "nvidia",
		baseUrl: "https://integrate.api.nvidia.com/v1",
		headers: {"NVCF-POLL-SECONDS":"3600"},
		compat: {"supportsStore":false,"supportsDeveloperRole":false,"supportsReasoningEffort":false,"maxTokensField":"max_tokens","supportsStrictMode":false,"supportsLongCacheRetention":false},
		reasoning: true,
		input: ["text"],
		cost: {
			input: 0,
			output: 0,
			cacheRead: 0,
			cacheWrite: 0,
		},
		contextWindow: 131072,
		maxTokens: 32768,
	} satisfies Model<"openai-completions">,
	"qwen/qwen3.5-122b-a10b": {
		id: "qwen/qwen3.5-122b-a10b",
		name: "Qwen3.5 122B-A10B",
		api: "openai-completions",
		provider: "nvidia",
		baseUrl: "https://integrate.api.nvidia.com/v1",
		headers: {"NVCF-POLL-SECONDS":"3600"},
		compat: {"supportsStore":false,"supportsDeveloperRole":false,"supportsReasoningEffort":false,"maxTokensField":"max_tokens","supportsStrictMode":false,"supportsLongCacheRetention":false},
		reasoning: true,
		input: ["text", "image"],
		cost: {
			input: 0,
			output: 0,
			cacheRead: 0,
			cacheWrite: 0,
		},
		contextWindow: 262144,
		maxTokens: 65536,
	} satisfies Model<"openai-completions">,
	"stepfun-ai/step-3.5-flash": {
		id: "stepfun-ai/step-3.5-flash",
		name: "Step 3.5 Flash",
		api: "openai-completions",
		provider: "nvidia",
		baseUrl: "https://integrate.api.nvidia.com/v1",
		headers: {"NVCF-POLL-SECONDS":"3600"},
		compat: {"supportsStore":false,"supportsDeveloperRole":false,"supportsReasoningEffort":false,"maxTokensField":"max_tokens","supportsStrictMode":false,"supportsLongCacheRetention":false},
		reasoning: true,
		input: ["text"],
		cost: {
			input: 0,
			output: 0,
			cacheRead: 0,
			cacheWrite: 0,
		},
		contextWindow: 256000,
		maxTokens: 16384,
	} satisfies Model<"openai-completions">,
	"stepfun-ai/step-3.7-flash": {
		id: "stepfun-ai/step-3.7-flash",
		name: "Step 3.7 Flash",
		api: "openai-completions",
		provider: "nvidia",
		baseUrl: "https://integrate.api.nvidia.com/v1",
		headers: {"NVCF-POLL-SECONDS":"3600"},
		compat: {"supportsStore":false,"supportsDeveloperRole":false,"supportsReasoningEffort":false,"maxTokensField":"max_tokens","supportsStrictMode":false,"supportsLongCacheRetention":false},
		reasoning: true,
		input: ["text", "image"],
		cost: {
			input: 0,
			output: 0,
			cacheRead: 0,
			cacheWrite: 0,
		},
		contextWindow: 256000,
		maxTokens: 16384,
	} satisfies Model<"openai-completions">,
	"z-ai/glm-5.2": {
		id: "z-ai/glm-5.2",
		name: "GLM-5.2",
		api: "openai-completions",
		provider: "nvidia",
		baseUrl: "https://integrate.api.nvidia.com/v1",
		headers: {"NVCF-POLL-SECONDS":"3600"},
		compat: {"supportsStore":false,"supportsDeveloperRole":false,"supportsReasoningEffort":false,"maxTokensField":"max_tokens","supportsStrictMode":false,"supportsLongCacheRetention":false},
		reasoning: true,
		input: ["text"],
		cost: {
			input: 0,
			output: 0,
			cacheRead: 0,
			cacheWrite: 0,
		},
		contextWindow: 1000000,
		maxTokens: 131072,
	} satisfies Model<"openai-completions">,
} as const;
